import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'renewal.ea.directives.templates.ea-edit-coverage.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    eaCoverages: {
        id: 'renewal.ea.directives.templates.ea-edit-coverage.Coverages',
        defaultMessage: 'Coverages'
    },
    lineCoverages: {
        id: 'renewal.ea.directives.templates.ea-edit-coverage.Line Coverages',
        defaultMessage: 'General Coverages (Apply to all vehicles)'
    },
    vehicleCoverages: {
        id: 'renewal.ea.directives.templates.ea-edit-coverage.Vehicle Coverages',
        defaultMessage: 'Vehicle Coverages'
    },
    saveCoverageError: {
        id: 'renewal.ea.config.Unable to save coverages change',
        defaultMessage: 'Unable to save coverages change'
    },
    saveCoverageErrorMessage: {
        id: 'renewal.ea.config.An error occurred while attempting to save coverage changes',
        defaultMessage: 'An error occurred while attempting to save coverage changes'
    },
    nextLabel: {
        id: 'renewal.ea.quotePage.Next',
        defaultMessage: 'Next'
    },
    recalculateLabel: {
        id: 'renewal.ea.quotePage.Recalculate',
        defaultMessage: 'Recalculate'
    }
});
